webpackJsonp([113],{

/***/ 2457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReenableAccount_vue__ = __webpack_require__(3640);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aee2e82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReenableAccount_vue__ = __webpack_require__(4415);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4413)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReenableAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aee2e82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReenableAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/public/account/ReenableAccount.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6aee2e82", Component.options)
  } else {
    hotAPI.reload("data-v-6aee2e82", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_AccountRepository__ = __webpack_require__(184);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BInputGroup: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_25" /* BInputGroup */],
    BInputGroupAppend: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_26" /* BInputGroupAppend */],
    BFormInput: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["s" /* BFormInput */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["t" /* BFormInvalidFeedback */],
    BButton: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["d" /* BButton */]
  },
  data: function data() {
    return {
      success: false,
      initial: true,
      error: null,
      submitted: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this.$route.query.token && _this.$route.query.email)) {
                _context.next = 3;
                break;
              }

              _context.next = 6;
              break;

            case 3:
              _this.initial = false;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3__repositories_AccountRepository__["a" /* default */].reenableAccount(_this.$route.query.token).then(function (response) {
                _this.success = response.data;
                if (!response.data || response.status !== 200) {
                  _this.error = 'reenable-user';
                  _this.success = false;
                } else {
                  _this.error = null;
                }
              });

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    resendEnableAccountEmail: function resendEnableAccountEmail() {
      var _this2 = this;

      this.submitted = true;
      if (this.emailValidation !== false) {
        this.$api.get('Cognito/ResendEnableUserEmail', {
          params: {
            email: this.email
          }
        }).then(function (response) {
          if (response.data.data) {
            _this2.initial = false;
            _this2.error = null;
          } else {
            _this2.error = 'resend-enable-user';
          }
        });
      }
    }
  },
  computed: {
    token: function token() {
      return this.$route.query.token;
    },
    email: function email() {
      return this.$route.query.email ? this.$route.query.email.replace(' ', '+') : null;
    },

    emailValidation: function emailValidation() {
      return this.$validators.validate(this.email, ['required', 'email'], this.submitted);
    }
  }
});

/***/ }),

/***/ 4413:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4414);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("b2883378", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6aee2e82\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ReenableAccount.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6aee2e82\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ReenableAccount.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4414:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 4415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.initial
      ? _c("div", [
          _vm.success
            ? _c(
                "span",
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("account-reenable-success"))
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    { attrs: { tag: "a", to: "/inicio-sesion" } },
                    [_vm._v(_vm._s(_vm.$helpers.getV2AppUrl("inicio-sesion")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.error
            ? _c(
                "span",
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("account-reenable-fail")) + " "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    { attrs: { to: "/inicio-sesion", tag: "a" } },
                    [_vm._v(_vm._s(_vm.$helpers.getV2AppUrl("inicio-sesion")))]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _c("div", [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("resend-account-enable-email-success", {
                  email: _vm.email
                })
              ) +
              "\n  "
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6aee2e82", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/113.98b8cdfb2cf151e0cd98.js